import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { Log } from '@/types/log.types';

interface RealtimeLog extends Log {
  receivedAt: Date;
}

interface CriticalError {
  id: string;
  message: string;
  stackTrace?: string;
  deviceId: string;
  userId?: string;
  timestamp: string;
}

interface LogsState {
  logs: RealtimeLog[];
  criticalErrors: CriticalError[];
  maxLogs: number;
  addLog: (log: Log) => void;
  addCriticalError: (error: CriticalError) => void;
  clearLogs: () => void;
  clearCriticalErrors: () => void;
  setMaxLogs: (max: number) => void;
}

export const useLogsStore = create<LogsState>()(
  persist(
    (set) => ({
      logs: [],
      criticalErrors: [],
      maxLogs: 500,

      addLog: (log: Log) =>
        set((state) => {
          const newLog: RealtimeLog = {
            ...log,
            receivedAt: new Date(),
          };

          const updated = [...state.logs, newLog];
          return {
            logs: updated.length > state.maxLogs ? updated.slice(-state.maxLogs) : updated,
          };
        }),

      addCriticalError: (error: CriticalError) =>
        set((state) => ({
          criticalErrors: [error, ...state.criticalErrors].slice(0, 50),
        })),

      clearLogs: () => set({ logs: [] }),

      clearCriticalErrors: () => set({ criticalErrors: [] }),

      setMaxLogs: (max: number) => set({ maxLogs: max }),
    }),
    {
      name: 'curral-tech-logs',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        criticalErrors: state.criticalErrors,
        maxLogs: state.maxLogs,
      }),
    }
  )
);
